import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Service } from './refresh-restore.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { DataProtectionVariables } from '../../dataprotection-common/dataprotection-variables';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'refresh-restore',
  providers: [
    Service, TranslateService
  ],
  styles: [require('./refresh-restore.scss')],
  template: require('./refresh-restore.html')
})

export class RefreshRestore {
  @Input('isVisible') isVisible: boolean;
  @Input('mode') mode: string;
  @Input('selectedObject') selectedObject;
  @Input('selectedVDC') selectedVDC;
  @Output('onClose') selfClose = new EventEmitter();

  private subscribeHandler;
  private submitted: boolean = false;
  private active: boolean = true;
  private vAppName = "";
  private vdcName = "";
  private isRequestPending: boolean = false;

  constructor(public service: Service, private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

  onSubmit() {
    switch(this.mode){
      case DataProtectionVariables.RESTORE_MODES['VAPP']:
        this.refreshRestorePointsVapp();
        break;
      case DataProtectionVariables.RESTORE_MODES['DELETED_VAPP']:
        this.refreshRestorePointsDeletedVapp();
        break;
      default :
        this.refreshRestorePointsVapp();
    }
  }

  onSubmitButtonClicked(f: NgForm) {
  }

  onCancelButtonClicked() {
    this.closeSelf();
  }

  //Life Cycle Hooks
  ngOnInit() {
  }

  ngOnChanges(changes) {
    if(changes && changes.hasOwnProperty('isVisible') && changes.isVisible && changes.isVisible.hasOwnProperty('currentValue') && changes.isVisible.currentValue
        && this.selectedVDC && this.selectedObject && this.selectedObject.name) {
        this.vAppName = this.selectedObject.name;
        this.vdcName = (this.selectedVDC.name)? this.selectedVDC.name : "";
    }
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    if(this.subscribeHandler) this.subscribeHandler.unsubscribe();
  }

  refreshRestorePointsVapp() {
    if(this.selectedVDC && this.selectedVDC.id && this.selectedVDC.id !== '' && this.selectedObject && this.selectedObject.id && this.selectedObject.id !== '') {
      this.isRequestPending = true;
      this.subscribeHandler = this.service.refreshRestorePointsVapp(this.selectedVDC.id, this.selectedObject.id)
        .subscribe(
          res => {
            this.closeSelf();
          },
          error => this.logError(error, 'refresh restore points for vapp'),
          () => this.logOperationCompleted('refresh restore points for vapp')
        );
    }
    else
      this.logError('Incorrect VDC or vApp information while deleting restore points for vapp');
  }

  refreshRestorePointsDeletedVapp() {
    if(this.selectedVDC && this.selectedVDC.id && this.selectedVDC.id !== '' && this.selectedObject && this.selectedObject.id && this.selectedObject.id !== '') {
      this.isRequestPending = true;
      this.subscribeHandler = this.service.refreshRestorePointsDeletedVapp(this.selectedVDC.id, this.selectedObject.id)
        .subscribe(
          res => {
            this.closeSelf();
          },
          error => this.logError(error, 'refresh restore points for deleted vapp'),
          () => this.logOperationCompleted('refresh restore points for deleted vapp')
        );
    }
    else
      this.logError('Incorrect VDC or vApp information while deleting restore points for deleted vapp');
  }

  closeSelf() {
    if (this.selfClose) {
      this.selfClose.emit({
        value: "close"
      });
    }
  }


  logError(error, origin:String = '') {
    console.error('Error: ', error, (origin !== '')? " Error from " + origin : "");
    this.isRequestPending = false;
  }

  logOperationCompleted(msg: string) {
    console.log('Operation Completed: ', msg)
    this.isRequestPending = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/refresh-restore/refresh-restore.component.ts